import React from 'react';
import { useTranslation } from 'react-i18next';
import { HighlightSection } from '../styles';

export const SectionTwo = () => {
    const { t } = useTranslation();

    return (
        <div>
            <div>
                <strong>{t('additional_info.script.credit_score')}</strong>
            </div>
            <div>{t('additional_info.script.5')}</div>
            <p>
                <HighlightSection as='span'>
                <em>{t('additional_info.script.rebuttal3')}</em>
                </HighlightSection>
            </p>
        </div>
    );
};
